import { graphql } from 'gatsby'
import { normalizedData } from '@utils'
import Layout from '@layout'
import Header from '@layout/header/layout-01'
import Footer from '@layout/footer/layout-01'
import PageHeader from '@containers/page-header/layout-04'
import HomeArea from '@containers/home/layout-01'
import HomeBoxImagesArea from '@containers/home/layout-02'

const HomePage = ({ location, data }) => {
  const content = normalizedData(data?.strapiPage?.content || [])

  return (
    <Layout location={location}>
      <Header />
      <main className="site-wrapper-reveal">
        <PageHeader data={content['header-section']} />
        <HomeArea data={content['home-section']} />
        <HomeBoxImagesArea data={content['box-section']} />
      </main>
      <Footer />
    </Layout>
  )
}

export { Head } from '@components/head'

export const query = graphql`
  query homePageQuery($locale: String) {
    strapiPage(
      title: { eq: "home" }
      pageType: { eq: "frontpage" }
      locale: { eq: $locale }
    ) {
      content {
        ...StrapiPageContent
      }
      seo {
        ...StrapiPageSEO
      }
    }
  }
`

export default HomePage
